export default [
  // { text: 'Pending', value: null },
  { text: 'Paused', icon: 'fa-pause', value: 'PAUSED', color: '#ffffff', backgroundColor: '#6e8ca2' },
  { text: 'Strategy', icon: 'fa-chess-king', value: 'STRATEGY', color: '#ffffff', backgroundColor: '#548dd4' },
  { text: 'In Progress', icon: 'fa-hourglass-half', value: 'CREATION', color: '#ffffff', backgroundColor: '#f99433' },
  { text: 'Under Review', icon: 'fa-magnifying-glass-plus', value: 'REVIEW', color: '#ffffff', backgroundColor: '#cd4458' },
  { text: 'Completed', icon: 'fa-circle-check', value: 'DONE', color: '#ffffff', backgroundColor: '#00ae80' }
]
